<app-slide-dialog-layout [showCloseButton]="!deploymentProgress()" (dismissed)="dismiss()">
    @if (!deploymentProgress()) {
        <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    }

    <div title>
        <div class="flex flex-wrap items-center justify-center gap-2">
            @if (deploymentProgress() !== 'finished') {
                @switch (updateMode()) {
                    @case (firmwareUpdateMode.UPDATE) {
                        <span [translate]="'GET_READY_TO_UPDATE'" i18n="@@GET_READY_TO_UPDATE">
                            Get ready to update
                        </span>
                        <div
                            class="inline-flex items-center gap-1 rounded-md px-2 py-1"
                            dcBgColor="gold-yellow"
                            dcTypography="geist-12-semibold">
                            v{{ currentFirmwareUpdate()?.name }}
                        </div>
                    }
                    @case (firmwareUpdateMode.FORCE) {
                        <span [translate]="'FORCING_UPDATE'" i18n="@@FORCING_UPDATE">Forcing update</span>
                        <div
                            class="inline-flex items-center gap-1 rounded-md px-2 py-1"
                            dcBgColor="gold-yellow"
                            dcTypography="geist-12-semibold">
                            v{{ firmware()?.name }}
                        </div>
                    }
                    @case (firmwareUpdateMode.REPAIR) {
                        <span [translate]="'GET_READY_TO_REPAIR'" i18n="@@GET_READY_TO_REPAIR">
                            Get ready to repair
                        </span>
                        <div
                            class="inline-flex items-center gap-1 rounded-md px-2 py-1"
                            dcBgColor="gold-yellow"
                            dcTypography="geist-12-semibold">
                            v{{ selectedVirt().firmware.name }}
                        </div>
                    }
                    @case (firmwareUpdateMode.ROLLBACK) {
                        <span [translate]="'GET_READY_TO_ROLLBACK'" i18n="@@GET_READY_TO_ROLLBACK">
                            Get ready to rollback
                        </span>
                    }
                }
            } @else {
                @if (!deploymentState()?.failure) {
                    <span [translate]="'UPDATE_SUCCESSFUL'" i18n="@@UPDATE_SUCCESSFUL">Update successful</span>
                } @else {
                    <span [translate]="'UPDATE_FAILED'" i18n="@@UPDATE_FAILED">Update failed</span>
                }
            }
        </div>
    </div>

    <div class="flex w-full flex-col items-center">
        @if (deploymentProgress() !== 'finished') {
            @if (updateInProgress()) {
                <div class="mb-4 mt-2 w-full text-center" dcColor="bullseye-black">
                    {{ PLEASE_LEAVE_THE_DEVICE_POWERED_ON_DURING_UPDATE() }}
                </div>

                <div class="update-progress indeterminate w-full"></div>

                <app-loading-text
                    class="mt-4 block"
                    [messages]="loadingMessages()"
                    [interval]="4500"></app-loading-text>
            } @else {
                @switch (updateMode()) {
                    @case (firmwareUpdateMode.REPAIR) {
                        <div
                            class="w-full rounded-xl px-4 py-3 text-center"
                            dcBgColor="wire-white"
                            dcColor="bullseye-black">
                            <span [translate]="'UPDATE_REPAIR_CONFIRMATION'" i18n="@@UPDATE_REPAIR_CONFIRMATION">
                                You are about to run the Repair function. This will reinstall the current software
                                version. Use this only if you are experiencing connection issues likely caused by a
                                faulty update. Keep the device powered on during the repair.
                            </span>
                        </div>
                    }
                }

                <!-- <div class="mt-3 w-full space-y-3 text-center">
                    @if (currentConnectionStatus() === connectionStatus.CONNECTED) {
                        @if (versionHelper.isVersionSameOrAbove(selectedOmni().firmware.version_key, '1.1.0')) {
                            <div
                                dcColor="bullseye-black"
                                [translate]="'UPDATE_START_NO_REBOOT_REQUIRED'"
                                i18n="@@UPDATE_START_NO_REBOOT_REQUIRED">
                                After you start, Omni Scoring will begin updating automatically within one minute.
                                Please keep the device powered on during the update.
                            </div>
                        } @else {
                            <div
                                dcColor="bullseye-black"
                                [translate]="'UPDATE_START_REBOOT_REQUIRED'"
                                i18n="@@UPDATE_START_REBOOT_REQUIRED">
                                After you start, Omni Scoring will reboot automatically to check for updates. Please
                                keep the device powered on.
                            </div>
                        }
                    } @else {
                        <div
                            dcColor="bullseye-black"
                            [translate]="'UPDATE_DEVICE_OFFLINE_NOTICE'"
                            i18n="@@UPDATE_DEVICE_OFFLINE_NOTICE">
                            After you press proceed, please turn on Omni Scoring so it can download and install the
                            update.
                        </div>
                    }
                </div> -->

                @if (firmwareUpdateMode.UPDATE && currentFirmwareUpdate()?.release_notes_key) {
                    <div class="mt-4 text-center">
                        <button
                            type="button"
                            dcButton
                            class="underline"
                            dcTypography="geist-12-medium"
                            (click)="openReleaseNotes()">
                            <span
                                [translate]="'WHATS_NEW_FIRMWARE_UPDATE_NOTES'"
                                i18n="@@WHATS_NEW_FIRMWARE_UPDATE_NOTES">
                                What's new in this update
                            </span>
                        </button>
                    </div>
                }
            }
        } @else {
            <div class="flex flex-col items-center space-y-4 text-center">
                @if (deploymentState().success) {
                    <svg
                        dcColor="victory-green"
                        width="4.188rem"
                        height="4.125rem"
                        viewBox="0 0 67 66"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="1.5" width="63" height="63" rx="31.5" fill="currentColor" fill-opacity="0.05" />
                        <rect x="2" y="1.5" width="63" height="63" rx="31.5" stroke="currentColor" stroke-width="3" />
                        <g clip-path="url(#clip0_604_13944)">
                            <path
                                d="M28.0571 39.6505L22.1041 33.6975C21.4407 33.0342 20.3862 33.0342 19.7228 33.6975C19.0595 34.3608 19.0595 35.4154 19.7228 36.0787L26.8495 43.2053C27.5128 43.8687 28.5844 43.8687 29.2477 43.2053L47.2769 25.1932C47.9402 24.5298 47.9402 23.4753 47.2769 22.812C46.6135 22.1486 45.559 22.1486 44.8956 22.812L28.0571 39.6505Z"
                                fill="currentColor" />
                        </g>
                        <defs>
                            <clipPath id="clip0_604_13944">
                                <rect width="3.125rem" height="3.125rem" fill="white" transform="translate(8.5 8)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div
                        dcColor="treble-green-2"
                        [translate]="'YOUR_DEVICE_HAS_BEEN_UPDATED'"
                        i18n="@@YOUR_DEVICE_HAS_BEEN_UPDATED">
                        Your device has been updated. The device will now reboot to apply the update.
                    </div>
                } @else if (deploymentState()['already-installed']) {
                    <app-icon icon="warning" size="extralarge" dcColor="gold-yellow"></app-icon>
                    <div
                        dcColor="bullseye-black"
                        [translate]="'UPDATE_SKIPPED_ALREADY_INSTALLED'"
                        i18n="@@UPDATE_SKIPPED_ALREADY_INSTALLED">
                        The update skipped installation. The device seemed already up-to-date. If you want to force a
                        new update, please choose the 'repair' option from the device settings.
                    </div>
                } @else {
                    <app-icon icon="warning" size="extralarge" dcColor="bullseye-red"></app-icon>
                    <div
                        dcColor="bullseye-red"
                        [translate]="'YOUR_DEVICE_HAS_NOT_BEEN_UPDATED'"
                        i18n="@@YOUR_DEVICE_HAS_NOT_BEEN_UPDATED">
                        The update failed to apply due to unkown reasons. If this keeps happening, please get in touch
                        thorugh the contact form.
                    </div>
                }
            </div>
        }
    </div>

    @if (deploymentProgress() === 'finished') {
        <div class="flex flex-col gap-2 sm:flex-row">
            @if (deploymentState()?.failure) {
                <button type="button" class="mt-8 w-full" dcButton dcBgColor="ultimate-blue" (click)="retry()">
                    <span [translate]="'RETRY'" i18n="@@RETRY">Retry</span>
                </button>
            }

            <button type="button" class="mt-8 w-full" dcButton dcBgColor="oche-orange" (click)="dismiss()">
                <span [translate]="'CLOSE'" i18n="@@CLOSE">Close</span>
            </button>
        </div>
    } @else if (!updateInProgress()) {
        @switch (updateMode()) {
            @case (firmwareUpdateMode.UPDATE) {
                <button
                    type="button"
                    class="mt-8 w-full"
                    dcButton
                    dcBgColor="oche-orange"
                    [disabled]="startedUpdate()"
                    (click)="startUpdate()">
                    <span [translate]="'START_UPDATE'" i18n="@@START_UPDATE">Start update</span>
                </button>
            }
            @case (firmwareUpdateMode.REPAIR) {
                <button
                    type="button"
                    class="mt-8 w-full"
                    dcButton
                    dcBgColor="oche-orange"
                    [disabled]="startedUpdate()"
                    (click)="startUpdate()">
                    <span [translate]="'START_REPAIR'" i18n="@@START_REPAIR">Repair</span>
                </button>
            }
        }
    }
</app-slide-dialog-layout>
